import { MonetaryErosion } from '@norma/shared/types/monetaryErosion.type';
import { PrejudiceFormPerteGainsProfessionnelsActuelSaisieDirecte } from '@norma/shared/types/prejudice.type';
import { Victime } from '@norma/shared/types/victime.type';
import { Paragraph, Table, TableOfContents } from 'docx';
import { getEmptyLine } from 'src/helpers/print/docxFunctions';
import { indemnitesJournalieresPercuesPendantLaPeriodeDArretWrittenPrint } from '../../revenus/steps/indemnitesJournalieresPercuesPendantLaPeriodeDArret.written.print';
import { perteDeGainsProfessionnelsWrittenPrint } from '../../revenus/steps/perteDeGainsProfessionnels.written.print';
import { revenuEspereWrittenPrint } from './revenuEspere.written.print';

export const saisieDirecteStepsWrittenPrint = ({
  formData,
  victime,
  dateLiquidation,
  monetaryErosions,
  isPGPF,
}: {
  formData: PrejudiceFormPerteGainsProfessionnelsActuelSaisieDirecte;
  victime: Victime;
  dateLiquidation: Date | undefined;
  monetaryErosions: MonetaryErosion[];
  isPGPF: boolean;
}): (Table | TableOfContents | Paragraph)[] => {
  return [
    ...(formData.revenuEspere.total
      ? [
          ...revenuEspereWrittenPrint({
            formData,
            victime,
            isPGPF,
          }),
          getEmptyLine(),
        ]
      : []),
    ...(formData.perteDeGainsProfessionnels.total
      ? [
          ...perteDeGainsProfessionnelsWrittenPrint({
            formData,
            perteDeGainsProfessionnels: formData.perteDeGainsProfessionnels,
            dateLiquidation: dateLiquidation,
            monetaryErosions: monetaryErosions,
            revalorisationCoefficientsType:
              formData.revalorisationCoefficientsType,
            victime,
            isPGPF,
          }),
          getEmptyLine(),
        ]
      : []),
    ...(formData.indemnitesJournalieresPercuesPendantLaPeriodeDArret
      .indemnitesJournalieresPercuesNet ||
    formData.indemnitesJournalieresPercuesPendantLaPeriodeDArret.csgRdsTotal
      ? indemnitesJournalieresPercuesPendantLaPeriodeDArretWrittenPrint({
          formData,
          indemnitesJournalieresPercuesPendantLaPeriodeDArret:
            formData.indemnitesJournalieresPercuesPendantLaPeriodeDArret,
          victime,
          isPGPF,
        })
      : []),
  ];
};
